import { Directive, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

function minValidationFactory() {
	return (c: FormControl, minValidation) => {
		if (Number(c.value) < Number(minValidation)) {
			return {
				minValidation: true,
			}
		}

		return;
	}
}

@Directive({
  selector: '[minValidation][ngModel]',
  providers: [
    {
    	provide: NG_VALIDATORS,
    	useExisting: forwardRef(() => MinValidationDirective), multi: true
    }
  ]
})
export class MinValidationDirective {
  validator: Function;
  @Input() minValidation

  constructor() {
    this.validator = minValidationFactory();
  }

  validate(c: FormControl) {
    return this.validator(c, this.minValidation);
  }
}
